import { sessionSchema } from './schema';

export const onDeleteParticipantsFromSession = `
  subscription onDeleteParticipantsFromSession {
    onDeleteParticipantsFromSession {
      success
      message
      data
    }
  }
`;

export const onAddParticipantsToSession = `
  subscription onAddParticipantsToSession {
    onAddParticipantsToSession {
      success
      message
      data
    }
  }
`;

export const onHandleUpdateReplicaSessions = `
subscription onHandleUpdateReplicaSessions {
  onHandleUpdateReplicaSessions {
    create{
      ${sessionSchema}
    }
    edit{
      ${sessionSchema}
    }
    delete{
      id
    }
  }
}
`;

export const onUpdateSession = `
  subscription OnUpdateSession($filter:ModelSubscriptionSessionFilterInput){
    onUpdateSession(filter: $filter) {
      ${sessionSchema}
    }
  }
`;

export const onHandleSessionCreateEdit = `
  subscription onHandleSessionCreateEdit {
    onHandleSessionCreateEdit {
      success
      message
      data
    }
  }
`;

export const onDeleteSession = `
  subscription OnDeleteSession($filter:ModelSubscriptionSessionFilterInput) {
    onDeleteSession(filter: $filter) {
      id
      start_time
    }
  }
`;
